import MenuView from '../layouts/MenuView';
import EmptyRouter from '../views/EmptyRouter';
import AppStore from '../store/index';

console.log('[-> AppStore]', AppStore.state);
let homePage;
if (AppStore.state.isMobile) {
  homePage = '/mobile/';
} else {
  homePage = '/index/';
}
console.log('[-> homePage]', homePage);

const routers = [
  {
    path: '/',
    // redirect: '/index/',
    redirect: homePage,
    name: 'home',
    component: MenuView,
    invisible: true,
    children: [{
      path: '/admin/',
      alias: '/home',
      name: '首页',
      icon: 'home',
      component: () => import('../views/admin/Home')
    }, {
      path: '/admin/list',
      name: '报名管理',
      icon: 'bars',
      component: () => import('../views/admin/List')
    },{
      path: '/admin/order',
      name: '预约人数设置',
      icon: 'schedule',
      component: () => import('../views/admin/OrderLimit')
    }, {
      path: '/admin/report',
      icon: 'bar-chart',
      name: '报名统计',
      component: () => import('../views/admin/Report')
    }, {
      path: '/admin/street_detail',
      name: '报名情况',
      icon: 'solution',
      meta: { adminLevel: 'admin' },
      component: () => import('../views/admin/StreetDetail')
    }, {
      path: '/admin/school_detail',
      name: '报名情况',
      icon: 'solution',
      meta: { adminLevel: 'street|school' },
      component: () => import('../views/admin/SchoolDetail')
    }, {
      path: '/admin/edit_notice',
      name: '报名须知',
      icon: 'info-circle',
      meta: { adminLevel: 'admin' },
      component: () => import('../views/admin/EditNotice')
    }, {
      path: '/admin/edit_school',
      name: '学校管理',
      icon: 'schedule',
      meta: { systemLevel: 'kinder', adminLevel: 'admin' },
      component: () => import('../views/admin/EditSchool')
    },{
      path: '/admin/enroll',
      name: '录取名单',
      icon: 'file-text',
      meta: { adminLevel: 'admin' },
      component: () => import('../views/admin/EnrollList')
    }, {
      path: '/admin/403',
      name: '403',
      invisible: true,
      component: () => import('../views/exception/403')
    }, {
      path: '/admin/500',
      name: '500',
      invisible: true,
      component: () => import('../views/exception/500')
    }]
  }, {
    // 家长端-报名系统【无需显示在默认路由】
    path: '/index',
    redirect: '/index/index',
    name: '',
    component: EmptyRouter,
    children: [{
      path: '/index/index',
      component: () => import('../views/index/Index')
    }, {
      path: '/index/help',
      component: () => import('../views/index/Help')
    }, {
      path: '/index/enroll',
      component: () => import('../views/index/EnrollList')
    }, {
      path: '/index/login',
      component: () => import('../views/index/Login')
    }, {
      path: '/index/bm_notes',
      component: () => import('../views/index/BmNotes')
    }, {
      path: '/index/bm_login',
      component: () => import('../views/index/BmLogin')
    }, {
      path: '/index/bm_form',
      component: () => import('../views/index/BmForm')
    }, {
      path: '/index/bm_info',
      component: () => import('../views/index/BmInfo')
    }, {
      path: '/index/test_page',
      component: () => import('../views/index/TestPage')
    },{
      path:'/index/miniadmin',
      component: () => import('../views/admin/MiniAdmin')
    }]
  }, {
    // H5 家长端-报名系统【独立】
    path: '/mobile',
    redirect: '/mobile/index',
    name: '',
    component: EmptyRouter,
    children: [{
      path: '/mobile/index',
      component: () => import('../views/mobile/Index')
    }, {
      path: '/mobile/help',
      component: () => import('../views/mobile/Help')
    },{
      path: '/mobile/enroll',
      component: () => import('../views/mobile/EnrollList')
    }, {
      path: '/mobile/login',
      component: () => import('../views/mobile/Login')
    }, {
      path: '/mobile/bm_notes',
      component: () => import('../views/mobile/BmNotes')
    }, {
      path: '/mobile/bm_login',
      component: () => import('../views/mobile/BmLogin')
    }, {
      path: '/mobile/bm_form',
      component: () => import('../views/mobile/BmForm')
    }, {
      path: '/mobile/step1_upload_pic',
      component: () => import('../views/mobile/Step1UploadPic')
    }, {
      path: '/mobile/step2_student_info',
      component: () => import('../views/mobile/Step2StudentInfo')
    }, {
      path: '/mobile/step3_parent_info',
      component: () => import('../views/mobile/Step3ParentInfo')
    }, {
      path: '/mobile/step4_certify',
      component: () => import('../views/mobile/Step4Certify')
    }, {
      path: '/mobile/step4_kinder',
      component: () => import('../views/mobile/Step4Kinder')
    }, {
      path: '/mobile/step5_time',
      component: () => import('../views/mobile/Step5Time')
    }, {
      path: '/mobile/bm_info',
      component: () => import('../views/mobile/BmInfo')
    }]
  }, {
    path: '/admin/view_info',
    name: '查看详情',
    invisible: true,
    component: () => import('../views/admin/ViewInfo')
  }, {
    path: '*',
    icon: 'none',
    invisible: true,
    component:
    MenuView,
    children: [{
      path: '',
      name: '404',
      meta: {
        hideTab: true,
        leaveClose: true
      },
      component: () => import('../views/exception/404')
    }]
  }
];

export default routers;
